import React, { useState } from 'react';
import shahi from './asset/shahi.png'; 
import peshwai from './asset/peshwai.png'; 
import raj from './asset/raj.png'; 
import jijau from './asset/jijau.png'; 
import bramhani from './asset/bramhani.png'; 
import mastani from './asset/mastani.png'; 
import stiching from './asset/stiching.png'; 
import saree from './asset/saree.png'; // 
import onepiece from './asset/onepiece.png'; 
import lacha22 from './asset/lacha22.png'; 
import first from './asset/1.png';
import second from './asset/2.png'; 
import third from './asset/3.png'; 
import fourth from './asset/4.png'; 
import fifth from './asset/5.png';
import sixth from './asset/6.png';  
import seventh from './asset/7.png'; 
import eighth from './asset/8.png';   
import nineth from './asset/9.png';
import tenth from './asset/10.png'; 
import eleventh from './asset/11.png'; 
import twelfth from './asset/12.png'; 


const catalogData = {
  nauvari: [
    { id: 'n1', name: 'Shahi Mastani Nauvari', collection: 'Mastani Collection',  img: shahi },
    { id: 'n2', name: 'Traditional Peshwai Nauvari', collection: 'Rajashree Collection',  img: peshwai },
    { id: 'n3', name: 'Rajlakshmi Nauvari', collection: 'Avani Collection',  img: raj },
    { id: 'n4', name: 'Maratha Maa Jijau Nauvari', collection: 'Swarajya Collection',  img: jijau },
    { id: 'n5', name: 'Marathi Bramhani Nauvari', collection: 'Avani Collection',  img: bramhani },
    { id: 'n6', name: 'Simple Mastani Nauvari ', collection: 'Mastani Collection',  img: mastani },
  ],
  blouse: [
    { id: 'b1', name: 'Rajmudra Blouse', collection: 'Aarohi Embroidery',  img: first },
    { id: 'b2', name: 'Mayurvaibhav Blouse', collection: 'Heritage Artistry', img: second},
    { id: 'b3', name: 'Maharani Grace', collection: 'Premium Atelier',  img: third},
    { id: 'b4', name: 'Shahi Vaibhav Blouse', collection: 'Signature Cut',  img: fourth },

   

    { id: 'b9', name: 'Tuljai Luxury Jali Blouse', collection: 'Aarohi Embroidery',  img: nineth },
    { id: 'b10', name: 'Suvarna Rekha Blouse', collection: 'Heritage Artistry',  img: tenth},
    { id: 'b11', name: 'Shahi Angrakha Blouse', collection: 'Premium Atelier',  img: eleventh},
    { id: 'b12', name: 'Rajsi Pleated Blouse', collection: 'Signature Cut',  img: twelfth },


     { id: 'b5', name: 'Moraya Heritage Blouse', collection: 'Aarohi Embroidery', img: fifth },
    { id: 'b6', name: 'Suvarna Rekha Blouse', collection: 'Heritage Artistry', img: sixth},
    { id: 'b7', name: 'Rajwada Jacket Blouse', collection: 'Premium Atelier',  img: seventh},
    { id: 'b8', name: 'Tulja Signature Blouse', collection: 'Signature Cut',  img: eighth },
  ],
  others: [
    { id: 'o1', name: 'Premium Hand-Crafted One-Piece', collection: 'Royal Accessories', img: onepiece },
    { id: 'o2', name: 'Festive Fusion Lacha', collection: 'Modern Marathi Heritage', img: lacha22 },
    { id: 'o3', name: 'Traditional Pre-Stitched Saree', collection: 'Gifting & Festive',  img: saree },
    { id: 'o4', name: 'Heritage Customize Stiching', collection: 'Classic Accents',  img: stiching },
  ]
};

const ProductCatalog = () => {
  const [activeTab, setActiveTab] = useState('nauvari');

  return (
    <section className="bg-[#F9F6F0] py-24 px-6 md:px-12 lg:px-20 border-t border-[#5c1d24]/10">
      <div className="max-w-7xl mx-auto">
        
        {/* Section Heading matching the image style layout */}
        <div className="text-center max-w-2xl mx-auto mb-12 space-y-3">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#5c1d24]">
            संग्रह • The Lookbook
          </span>
          <h2 className="font-serif text-3xl md:text-4xl text-neutral-900 tracking-wide font-light">
            Designer Nauvari, Blouses, and Heritage Masterpieces
          </h2>
          <div className="w-16 h-[1px] bg-[#5c1d24] mx-auto mt-4"></div>
        </div>

        
        <div className="flex justify-center space-x-4 sm:space-x-8 mb-16 border-b border-neutral-200 pb-px max-w-md mx-auto">
          {['nauvari', 'blouse', 'others'].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-4 text-xs font-semibold uppercase tracking-widest transition-all duration-300 border-b relative ${
                activeTab === tab 
                  ? 'text-[#5c1d24] border-[#5c1d24] font-bold scale-105' 
                  : 'text-neutral-400 border-transparent hover:text-neutral-700'
              }`}
            >
              {tab === 'others' ? 'Others / Fusion' : `Designer ${tab}`}
            </button>
          ))}
        </div>

        {/* Dynamic Catalog Product Grid Layout matching image_6.jpeg structure */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
          {catalogData[activeTab].map((item) => (
            <div key={item.id} className="group cursor-pointer flex flex-col justify-between">
              
              {/* Image Window Frame */}
              <div className="relative overflow-hidden aspect-[2/3] bg-neutral-100 border border-neutral-200/40 shadow-xs rounded-sm">
                <img 
                  src={item.img} 
                  alt={item.name} 
                  className="w-full h-full object-cover grayscale-10 transition-transform duration-500 ease-out group-hover:scale-105 group-hover:grayscale-0"
                />
                
                {/* Visual Ribbon Banner Overlay (Matches image style label bar) */}
                <div className="absolute bottom-0 left-0 right-0 bg-[#5c1d24]/85 backdrop-blur-xs text-white text-center py-2 text-[10px] tracking-widest uppercase font-light border-t border-amber-500/10">
                  {item.collection}
                </div>
              </div>

              {/* Text Description Row right beneath the asset frame */}
              <div className="mt-4 flex flex-col sm:flex-row sm:items-start justify-between gap-1 px-1">
                <div className="space-y-0.5">
                  <h3 className="font-serif text-sm text-neutral-900 font-medium tracking-wide group-hover:text-[#5c1d24] transition-colors duration-300">
                    {item.name}
                  </h3>
                  <p className="text-[11px] text-neutral-400 font-light tracking-wide">
                    Bespoke Atelier
                  </p>
                </div>
                <span className="text-xs font-semibold font-sans text-neutral-800 shrink-0 sm:pt-0.5">
                  {item.price}
                </span>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ProductCatalog;